module.exports = __webpack_public_path__ + "static/media/orange-bg-landscape.3b1d0fa2.webp";